import React, { useState } from "react";
import { getStatusColor } from "../utils/hotelUtils";
import QuickStatusModal from "./QuickStatusModal";

const ClickableStatus = ({ room, onStatusChange }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });

  const handleStatusClick = (e) => {
    e.stopPropagation(); // Empêcher la navigation vers la chambre

    // Calculer la position de la modal par rapport au clic
    const rect = e.currentTarget.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    setModalPosition({
      top: rect.bottom + scrollTop,
      left: rect.left + scrollLeft,
    });

    setIsModalOpen(true);
  };

  const handleStatusChange = async (newStatus) => {
    try {
      await onStatusChange(room.id, newStatus);
    } catch (error) {
      console.error("Erreur lors du changement de statut:", error);
    }
  };

  const hasModule = room.devEUI && room.module_id;

  return (
    <>
      <button
        onClick={handleStatusClick}
        className={`
          inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium transition-all duration-150
          ${getStatusColor(room.status)}
          ${hasModule ? "hover:shadow-sm hover:scale-105 cursor-pointer" : "cursor-not-allowed opacity-60"}
        `}
        disabled={!hasModule}
        title={hasModule ? "Cliquer pour changer le statut" : "Aucun module associé - impossible de changer le statut"}
      >
        {room.status}
        {hasModule && (
          <svg className="ml-1 w-3 h-3 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        )}
      </button>

      <QuickStatusModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} currentStatus={room.status} onStatusChange={handleStatusChange} room={room} position={modalPosition} />
    </>
  );
};

export default ClickableStatus;
